import React, { useState } from "react";
import { SampleQuestionsList } from "./SampleQuestionsList";
import { Footer } from "./Footer";

export const ExpandedChatWindow = ({
  colors,
  company,
  onClose,
  isVisible,
  chatHeaderText,
  isMobile,
  bubbleColor
}) => {
  const {
    bg,
    textPrimary,
    border,
    inputBg,
    brand,
    footerBg,
    footerText,
    searchbarBg
  } = colors;

  const [message, setMessage] = useState("");

  if (!isVisible) return null;

  const handleSendMessage = () => {
    if (message.trim()) setMessage("");
  };

  const windowStyle = isMobile
    ? {
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        top: "40px",
        width: "100%",
        height: "calc(100% - 40px)",
        borderRadius: "12px 12px 0 0",
        boxShadow: "0 -4px 24px rgba(0,0,0,0.15)",
      }
    : {
        position: "absolute",
        bottom: "90px",
        right: "0",
        width: "clamp(280px, 80%, 350px)",
        height: "min(500px, calc(100% - 110px))",
        borderRadius: "12px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
      };

  return (
    <div
      style={{
        ...windowStyle,
        backgroundColor: bg,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        zIndex: 1001,
        animation: "slideUp 0.3s ease",
        maxHeight: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px 16px",
          borderBottom: `1px solid ${border}`,
          background: bubbleColor,
          flexShrink: 0,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 15, fontWeight: 600, color: "#ffffff" }}>
            {chatHeaderText || company || "Ansera AI"}
          </span>
        </div>
        <div
          onClick={onClose}
          style={{
            width: 28,
            height: 28,
            borderRadius: 6,
            background: "rgba(255,255,255,0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 16,
            cursor: "pointer",
          }}
        >
          ×
        </div>
      </div>

      <div
        style={{
          flex: "1 1 0",
          minHeight: 0,
          overflowY: "auto",
          padding: "14px",
          background: bg,
          display: "flex",
          flexDirection: "column",
          gap: 12,
        }}
      >
        <SampleQuestionsList
          questions={[]}
          textColor={textPrimary}
          borderColor={border}
          inputBg={inputBg}
        />
      </div>

      <div
        style={{
          padding: "10px 12px",
          borderTop: `1px solid ${border}`,
          background: bg,
          flexShrink: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            background: inputBg,
            border: `1px solid ${border}`,
            borderRadius: 10,
            padding: "8px 12px",
          }}
        >
          <input
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
            placeholder="Ask me a question..."
            style={{
              flex: 1,
              fontSize: 13,
              color: textPrimary,
              background: "transparent",
              border: "none",
              outline: "none",
              minWidth: 0,
            }}
          />
          <div
            onClick={handleSendMessage}
            style={{
              width: 32,
              height: 32,
              borderRadius: 8,
              background: brand,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#ffffff",
              fontSize: 14,
              flexShrink: 0,
              cursor: "pointer",
            }}
          >
            ➤
          </div>
        </div>
      </div>

      <Footer bg={footerBg} borderColor={border} textColor={footerText} brand={brand} />

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};